var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRemoteSelect',_vm._g(_vm._b({attrs:{"item-value":"id","item-text":(c) => (`${c.shop_platform}-${c.shop_name}`),"find_api":_vm.$util.api.third_party_shop_detail,"search_api":_vm.$util.api.third_party_shop_select_list,"item-default":{id: 0, shop_platform: '', shop_name: ''}}},'VRemoteSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }